import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Zap, Menu, X, MessageCircle } from 'lucide-react';
import { useState } from 'react';

const navLinks = [
  { to: '/', label: 'Strona glowna' },
  { to: '/blog', label: 'Blog' },
  { to: '/kontakt', label: 'Kontakt' },
];

export const PublicLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-card/80 backdrop-blur border-b border-border/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                <Zap className="h-4 w-4 text-primary" />
              </div>
              <span className="font-heading font-bold text-lg tracking-tight">Torr.pl</span>
            </Link>
            <div className="hidden md:flex items-center gap-6">
              {navLinks.map(l => (
                <Link key={l.to} to={l.to} className={`text-sm transition-colors duration-150 ${location.pathname === l.to ? 'text-primary font-medium' : 'text-muted-foreground hover:text-foreground'}`}>{l.label}</Link>
              ))}
            </div>
            <div className="hidden md:flex items-center gap-3">
              <Link to="/login"><Button variant="ghost" size="sm">Zaloguj sie</Button></Link>
              <Link to="/register"><Button size="sm">Zarejestruj sie</Button></Link>
            </div>
            <button className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
        {mobileOpen && (
          <div className="md:hidden border-t border-border/50 bg-card px-4 py-4 space-y-3">
            {navLinks.map(l => <Link key={l.to} to={l.to} className="block text-sm text-muted-foreground py-1" onClick={() => setMobileOpen(false)}>{l.label}</Link>)}
            <div className="flex gap-2 pt-2">
              <Link to="/login" className="flex-1"><Button variant="ghost" size="sm" className="w-full">Zaloguj</Button></Link>
              <Link to="/register" className="flex-1"><Button size="sm" className="w-full">Rejestracja</Button></Link>
            </div>
          </div>
        )}
      </nav>
      <main>{children}</main>
      {/* Footer */}
      <footer className="border-t border-border/50 bg-card/50 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Zap className="h-4 w-4 text-primary" />
                <span className="font-heading font-bold">Torr.pl</span>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">Platforma do masowej komunikacji marketingowej SMS i email z programem afiliacyjnym.</p>
              <a href="https://facebook.com/torrpl" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs text-primary hover:underline mt-3">Facebook</a>
            </div>
            <div>
              <h4 className="text-sm font-medium mb-3">Platforma</h4>
              <div className="space-y-2">
                <Link to="/register" className="block text-xs text-muted-foreground hover:text-foreground">Rejestracja</Link>
                <Link to="/login" className="block text-xs text-muted-foreground hover:text-foreground">Logowanie</Link>
                <Link to="/blog" className="block text-xs text-muted-foreground hover:text-foreground">Blog</Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium mb-3">Wspolpraca</h4>
              <div className="space-y-2">
                <p className="text-xs text-muted-foreground">Program afiliacyjny 50/50</p>
                <p className="text-xs text-muted-foreground">Monetyzacja baz kontaktow</p>
                <p className="text-xs text-muted-foreground">Darmowa wysylka SMS i email</p>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium mb-3">Kontakt</h4>
              <div className="space-y-2">
                <p className="text-xs text-muted-foreground">kontakt@torr.pl</p>
                <p className="text-xs text-muted-foreground">abuse@torr.pl</p>
                <Link to="/kontakt" className="block text-xs text-primary hover:underline">Formularz kontaktowy</Link>
              </div>
            </div>
          </div>
          <div className="border-t border-border/30 mt-8 pt-6 text-center space-y-1">
            <p className="text-xs text-muted-foreground font-medium">Cozacena sp. z o.o.</p>
            <p className="text-xs text-muted-foreground">ul. Slowincow 7, 78-100 Kolobrzeg | NIP: 6711844043 | tel. 887 332 665</p>
            <p className="text-[10px] text-muted-foreground/70 mt-2">&copy; 2026 Torr.pl — Platforma komunikacji marketingowej. Wszystkie prawa zastrzezone.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
